// The rankings the equipment insight cards show, kept out of the cards so the
// homepage's copy and the cards it renders can't disagree about them.

// Active items that have earned something, best profit (income less what the
// item cost) first. The MVP card shows [0], the runner-up [1].
export function rankByProfit(equipment = []) {
  return equipment
    .filter((e) => e.is_active !== false && (e.total_income || 0) > 0)
    .map((e) => ({ ...e, profit: (e.total_income || 0) - (e.purchase_price || 0) }))
    .sort((a, b) => b.profit - a.profit);
}

// Lifetime income per category, archived items included, largest first.
// Categories that have earned nothing are left out.
export function incomeByCategory(equipment = []) {
  const byCategory = {};
  equipment.forEach((item) => {
    const name = item.category || 'Other';
    byCategory[name] = byCategory[name] || { name, value: 0, count: 0 };
    byCategory[name].value += item.total_income || 0;
    byCategory[name].count += 1;
  });
  const categories = Object.values(byCategory)
    .filter((c) => c.value > 0)
    .sort((a, b) => b.value - a.value);
  const total = categories.reduce((sum, c) => sum + c.value, 0);
  return categories.map((c) => ({ ...c, share: total > 0 ? (c.value / total) * 100 : 0 }));
}

// How much of what an item (or kit) cost its income has earned back, as a
// percentage: 100 means it has paid for itself. The app's ROI is this less 100.
export function paidBackPercent(income, cost) {
  const price = Number(cost) || 0;
  return price > 0 ? ((Number(income) || 0) / price) * 100 : 0;
}

// Hire days left until income reaches `targetPercent` of the cost, at a day
// rate raised or lowered by `rateAdjustment` percent. The kit projection's
// "hire days remaining".
export function hireDaysToTarget({ cost, income, dayRate, targetPercent = 100, rateAdjustment = 0 }) {
  const rate = (Number(dayRate) || 0) * (1 + (Number(rateAdjustment) || 0) / 100);
  const remaining = Math.max(0, (Number(cost) || 0) * (targetPercent / 100) - (Number(income) || 0));
  return rate > 0 ? Math.ceil(remaining / rate) : 0;
}
